import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { i18nContext } from '@/components/pages/assessments/context/i18n.context';
import { displayContext } from '@/components/pages/assessments/context/display.context';
import { stepContext } from '@/components/pages/assessments/context/step.context';
import Button from '@/components/Button/Button';

const SkipButton = ({ isSkipped, onButtonClick, ...props }) => {
  const { t } = useContext(i18nContext);
  const { css } = useContext(displayContext);
  const { metadata } = useContext(stepContext);
  const buttons = metadata?.ui?.buttons || {};

  return (
    <>
      <hr className={css('option-skip-divider')} />
      <Button
        additionalClasses={`${css('option-selectable-btn')} text-start`}
        styles={{ width: 'full' }}
        shape="rounded"
        state={isSkipped ? 'selected' : 'unselected'}
        border={true}
        text={t(buttons.skip || 'Skip')}
        onButtonClick={onButtonClick}
      />
    </>
  );
};

SkipButton.propTypes = {
  isSkipped: PropTypes.bool,
  onButtonClick: PropTypes.func
};

export default SkipButton;
